<div class="container-fluid-scroller">
    <div class="container-fluid page-body-wrapper ">
        <div class="content-wrapper d-flex align-items-center auth">
            <div class="row flex-grow">
                <div class="col-lg-2"></div>

                <div class="col-lg-8">

                    <div class="row">

                        <div class="col-lg-7" style="padding-right:0px;padding-left:0px;" >
                            <div class="auth-form-light p-5" style="padding: 3rem 3rem 1rem 3rem !important;">

                                <!-- <img src="../../assets/POA_WebLogo.png" style="width:180px;height:70px;" /> -->
                                <img src="../../assets/POA_IconLogo.png" style="height:140px;" />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
                                <form class="">
                                    <div class="form-group" style="padding-bottom:11px;padding-top:3.2em;">
                                        <ul class="text-info" style="font-size:18px;">
                                            <li>
                                                Post Audit Of BoE..
                                            </li>
                                            <li>
                                                Avoid Stucking In Customs..
                                            </li>
                                            <li>
                                                License Mangement / Assessments..
                                            </li>
                                            <li>
                                                Analytics..
                                            </li>
                                        </ul>
                                    </div>

                                </form>
                            </div>
                        </div>


                        <div class="col-lg-5" style="padding-right:0px;padding-left:0px;">
                            <div class="auth-form-light text-left p-5" style="padding-bottom: 112px !important;">
                                <form class="" style="padding-top:48.1px;">
                                    <div class="form-group">
                                        <input type="text" placeholder="User Name" class="form-control form-control-lg" [(ngModel)]="UserName" [ngModelOptions]="{standalone: true}" style="width: 95%;" />
                                        
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control form-control-lg" id="password" [(ngModel)]="Password" [ngModelOptions]="{standalone: true}" style="width: 95%;"
                                            placeholder="Password">
                                            <i id="pass-status" class="fa fa-eye" aria-hidden="true" (click)="viewPassword()"></i>
                                    </div>
                               
                                    <div class="mt-3">
                                        <a class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                                           (click)="LoginClick()">SIGN IN</a>
                                    </div>
                                    <div class="my-2 d-flex justify-content-between align-items-center">

                                        <a class="auth-link text-black" style="opacity:.5;">Forgot password?</a>

                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="background-color: white;">
                        <div class="col-lg-12" style="padding-bottom: 15px; text-align: center;">
                            <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                            <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                          </div>
                    </div>
                </div>

                <div class="col-lg-2"></div>
            </div>


        </div>
        <!-- content-wrapper ends -->

        
    </div>
    
    <!-- page-body-wrapper ends -->
</div>
<!-- container-scroller -->
<footer class="footer text-center" style="padding-top:15px;">
    <div class="d-sm-flex justify-content-center">
        <span class="d-block d-sm-inline-block">
            © 2020 All Rights Reserved, Powered By
            <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                <img src="../../assets/Logo-V3.png" width="70" />
            </a>
        </span>

    </div>
</footer>